// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "host" + "." + "3e8dd66d10a1f8e18ac3" + ".min.css";
};